import { useQuery as useUrqlQuery } from 'urql';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';
import {
  SearchLandingPageBySlugQueryVariables,
  SearchLandingPageBySlugQuery as SearchLandingPageBySlugQueryType,
} from '../types';
import { SearchLandingPageBySlugQuery } from './searchLandingPageQuery';
import { extractQueryAsParamsFromUrl } from '../../app-kit/helpers/urlHelpers';
import { useShowAVMLoggedOut } from '../hooks/useShowAVMLoggedOut';
import { useFeatureRollout } from '@rea-argonaut/experiment';

const useSearchQueryVariable = (): SearchLandingPageBySlugQueryVariables => {
  const { slug } = useUrlContext();
  const propertyStatus = extractQueryAsParamsFromUrl(slug)?.propertyStatus;
  const showAVMData = useShowAVMLoggedOut();
  const showPrice = !(propertyStatus === 'OFF_MARKET' && !showAVMData);
  const toggleSuburbCTA = useFeatureRollout('suburb_cta').isEnabled();

  return {
    slug,
    imageFormatWebp: 'WEBP',
    showPrice,
    toggleSuburbCTA,
  };
};

export const useSearchLandingPageBySlugQuery = () => {
  const variables = useSearchQueryVariable();
  const [urqlResult] = useUrqlQuery<
    SearchLandingPageBySlugQueryType,
    SearchLandingPageBySlugQueryVariables
  >({
    query: SearchLandingPageBySlugQuery,
    variables,
  });

  const pageContent = urqlResult.data?.searchLandingPageBySlug;

  if (!pageContent || (pageContent && 'errorCode' in pageContent)) return null;

  return pageContent;
};
